<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>使用Trinka云
                            <br />在任意地方轻松写作</h1>
                        <p>直接在您喜欢的浏览器上访问Trinka，随时随地更好地写作。 Trinka会将您的文件保存在云中！</p>
                        <a id="TrinkaCloudGetStarted" href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">开始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/cloud_banner_img.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>工作原理</h2>
                            <div class="HeadingSubLine"></div>
                        </div>

                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/RegisterAndLogin.png" alt="" style="    width: 46px;  height: 45px;">
                                </div>
                                <h3>注册 /
                                    <br /> 登录</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="" style="width: 36px; height: 45px;">
                                </div>
                                <h3>键入或导入文件</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="" style="    width: 36px;  height: 46px;">
                                </div>
                                <h3>提高写作水平</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Trinka 云的主要功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka云使您可以在任意地方写作。通过实时更正，Trinka始终伴随着您。 Trinka Web编辑器功能丰富，可以自动保存您的工作。 更棒的是您也可以导入和导出文档！ 有效写作就是如此便捷！</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-lg-4 col-md- dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/autoFileEdit_icon.svg" alt="">
                        <h3>自动文件编辑</h3>
                        <p>上传您的MS Word文档，Trinka会在几分钟内自动对其进行编辑。 然后您可以下载并定稿。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/ppc_icon.png" width="40" height="40" alt="">
                        <h3>抄袭检测</h3>
                        <p>先进的文本相似性检测算法，高质量的抄袭检查， iThenticate技术支持，最大的付费出版物数据库。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>专业领域和文档类型</h3>
                        <p>根据专业领域和文档类型定制Trinka，为您提供最相关的建议。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/PublicationReadiness.svg" alt="">
                        <h3>出版准备检查</h3>
                        <p>通过从期刊选择到道德合规的20多项检查来评估您的文稿，从而提高论文被期刊录用的机会。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/ConsistencyCheck_icons.png" alt="">
                        <h3>一致性检查</h3>
                        <p>Trinka的一致性检查将帮助您修订难以发现的不一致之处，特别是文档比较冗长的情况。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards commingSoonTag c-card">
                        <img src="assets/images/reference-quality.png" alt="">
                        <h3>引文检查器</h3>
                        <p>识别可能削弱您的研究前提和论证的引文，帮助您为您的论文引用可信的、权威的引文。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/style_guide_icon.svg" alt="">
                        <h3>风格指南设定</h3>
                        <p>根据常用的学术风格指南（AMA第11版、AGU 2017等等）调整手稿的语法和单词选择。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="assets/images/AddtoDictionary.svg" alt="">
                        <h3>添加到词典</h3>
                        <p>将自己的单词添加到“我的词典”中，这样Trinka就不会在将来的写作中将其标记为拼写错误。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards commingSoonTag c-card">
                        <img src="assets/images/sendForHumanEditing.svg" alt="">
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>发送进行人工编辑</h3>
                        <p>需要专家为您的最终稿件进行人工编辑吗？直接从Trinka编辑工具将其发送给英论阁的专家进行编辑。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="uploadContentSection">
                <h2>瞬息之间便可从云端<br />
                    导入文件进行编辑</h2>
                <ul>
                    <!-- <li>
                        <div class="uploadFileIcon">
                            <svg width="60" height="54" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4D4D4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>Trinka My Drive</p>
                    </li> -->
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4D4D4D"/>
                                <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>My Device</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8871)">
                                <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8871">
                                <rect width="24" height="20.4375" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >DropBox</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                            </svg>
                        </div>
                        <p >Google Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="42" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8873)">
                                <path d="M14.4991 10.3764L19.453 5.63883C18.424 1.62633 14.3371 -0.792141 10.3246 0.236954C8.51775 0.700347 6.9484 1.8204 5.92285 3.37852C5.99945 3.37664 14.4991 10.3764 14.4991 10.3764V10.3764Z" fill="#0364B8"/>
                                <path d="M9.15169 4.27053L9.1515 4.27137C8.20489 3.68508 7.11319 3.37519 5.99972 3.37671C5.97403 3.37671 5.94872 3.37831 5.92303 3.37859C2.61113 3.41965 -0.0405003 6.13784 0.000468414 9.44985C0.0153465 10.6512 0.390719 11.8204 1.07794 12.8059L8.49966 11.8764L14.1897 7.28825L9.15169 4.27053V4.27053Z" fill="#0078D4"/>
                                <path d="M19.4529 5.63899C19.3434 5.63124 19.2337 5.62714 19.1239 5.62671C18.4593 5.62607 17.8017 5.7618 17.1917 6.02552L17.1915 6.02506L14.1895 7.28834L17.499 11.3765L23.4156 12.8147C24.6924 10.4444 23.8059 7.48784 21.4356 6.21096C20.8231 5.88105 20.1471 5.68606 19.4529 5.63909V5.63899Z" fill="#1490DF"/>
                                <path d="M1.07812 12.8058C1.63023 13.5996 2.36625 14.248 3.22333 14.6956C4.08041 15.1432 5.03308 15.3767 6 15.3762H19.1244C20.0044 15.3764 20.868 15.1384 21.6236 14.6874C22.3792 14.2364 22.9987 13.5893 23.4161 12.8146L14.1899 7.28809L1.07812 12.8058V12.8058Z" fill="#28A8EA"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8873">
                                <rect width="24" height="15.4688" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >OneDrive</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <div class="app_name_content" routerLink="/wordplugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Others_App_MSWord.svg" alt="">
                                        <h3>
                                            <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                            <br />插件</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/other_Apps_browser.svg" alt="">
                                        <h3>浏览器插件</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                        <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                        <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                    </div>
                                </li>
                                <!-- <li>
                                    <div class="app_name_content"  routerLink="/trinkacloud">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                        <h3><span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>